/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, string,
} from 'prop-types';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import mbpLogger from 'mbp-logger';

import { getCheckoutVariation } from '../../../state/ducks/Checkout/ducks/Common/Common-Selectors';

const Loader = ({ error }) => {
    if (error) {
        mbpLogger.logError({
            function: 'Loader',
            module: 'mbp-pwa-ui',
            jsError: error,
            message: 'Checkout loadable route failed',
        });
    }
    return <div />;
};

Loader.propTypes = {
    error: object,
};
Loader.defaultProps = {
    error: null,
};

const LoadableCheckoutFloral = Loadable({
    loader: () => import(/* webpackChunkName: "CheckoutFloral" */ './CheckoutFloral'),
    loading: Loader,
});

const LoadableCheckoutFood = Loadable({
    loader: () => import(/* webpackChunkName: "CheckoutFood" */ './CheckoutFood'),
    loading: Loader,
});

const Checkout = ({ isCheckoutVariation }) => {
    // TODO remove one when apple pay is fixed.
    mbpLogger.logDebug({
        function: 'Checkout',
        module: 'Checkout.js',
        message: 'variation called',
        isCheckoutVariation,
    });

    if (isCheckoutVariation === 'floral') {
        return <LoadableCheckoutFloral />;
    }
    if (isCheckoutVariation === 'food') {
        return <LoadableCheckoutFood />;
    }
    return null;
};

const mapStateToProps = (state) => ({
    isCheckoutVariation: getCheckoutVariation(state),
});

Checkout.propTypes = {
    isCheckoutVariation: string.isRequired,
};

export default connect(mapStateToProps)(Checkout);
